import script from "./languageSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./languageSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./languageSwitcher.vue?vue&type=style&index=0&id=5667ed3e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5667ed3e"]])

export default __exports__